<template>
  <div class="mod-rela__courseChoice">
    <el-card shadow="never"
             class="aui-card--fill">
      <el-form label-position="left"
               @keyup.enter.native="queryCourse()"
               label-width="auto"
               class="single-search-condition"
               :model="dataForm">
        <el-row>
          <el-col :span="7">
            <el-form-item class="jump-popup-course" :label="$t('couse.course')">
              <el-input v-model="dataForm.coursename"
                          clearable
                          :placeholder="$t('res.courseclassroomrela.courseNoPlaceholder')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item class="jump-popup-coursefenlei" :label="$t('couse.coursecatalogid')">
              <catalogtree @cateloglist="cateloglist"
                          :defaultProps="defaultPropsz"
                          :showArray="showVehicleClassList"
                          :showValue="showValue"
                          :url="queryTreeUrl"
                          :isSelect=false
                          :status="'classStatus'"
                          ref="catalogtree"></catalogtree>

            </el-form-item>
          </el-col>
          <el-col :span="7">
            <div style="width:100%; display:flex">
              <div class="jump-popup-teamfenlei" style="width:60%">
                <el-form-item prop="courseTeamCatalogFirst"
                            style="width:100% !important"
                            :label="$t('couse.courseteamcatalogid')">
                  <div class="box01"
                      style="width: auto; float: left;">
                    <el-select v-model="dataForm.courseTeamCatalogFirst"
                              :placeholder="$t('cert.selectTips')"
                              @change="GetcourseTeamCatalog($event)"
                              clearable>
                      <el-option v-for="item in select1"
                                :key="item.code"
                                :label="item.name"
                                :value="item.code">
                      </el-option>
                    </el-select>
                  </div>
                </el-form-item>
              </div>
              <div style="width:32%;margin-left:3px;" class="certTeamCatalogSecondSel">
                <div class="box02" style="width: 60%; float: left;">
                  <el-select v-model="dataForm.selectCatalogSecond"
                            :placeholder="$t('cert.selectTips')"
                            :loading="loading"
                            clearable>
                    <el-option v-for="item in select2"
                              :key="item.code"
                              :label="item.name"
                              :value="item.code"></el-option>
                  </el-select>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="3">
            <el-button type="primary"
                        @click="queryCourse()">{{ $t('query') }}</el-button>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="3">
            <el-button type="primary" @click="couronOk()">{{$t('confirm')}}</el-button>
          </el-col>
          <el-col :span="18">&nbsp;</el-col>
          <el-col :span="3">
            <el-button class="el-back" style="margin-bottom: 7px" type="info" @click="init()">{{$t('reset')}}</el-button>
          </el-col>
        </el-row>
      </el-form>
      <div class="selectRadioClass">
      <el-table v-loading="dataListLoading"
                :data="dataList"
                border
                @select="selectRedio"
                style="width: 100%;"
                ref="coursePlanTable">
        <el-table-column type="selection"
                          header-align="center"
                          align="center"
                          width="50"></el-table-column>
        <!--课程编号-->
        <el-table-column prop="courseCode"
                        :label="$t('couse.coursecode')"
                        header-align="center"
                        align="center"
                        width="110"
                        show-overflow-tooltip></el-table-column>
        <!--课程中文名称-->
        <el-table-column prop="courseNameCn"
                        :label="$t('couse.coursenamecn')"
                        header-align="center"
                        align="left"
                        width="180"
                        show-overflow-tooltip></el-table-column>
        <!--课程分类-->
        <el-table-column prop="courseCatalogName"
                        :label="$t('couse.coursecatalogid')"
                        header-align="center"
                        align="center"
                        show-overflow-tooltip></el-table-column>
        <!--课程团队分类 -->
        <el-table-column prop="courseTeamCatalogName"
                        :label="$t('couse.courseteamcatalogid')"
                        header-align="center"
                        show-overflow-tooltip
                        align="center"></el-table-column>
        <!--最大人数-->
        <el-table-column prop="maxNumber"
                        :label="$t('couse.maxnumber')"
                        header-align="center"
                        show-overflow-tooltip
                        align="center"></el-table-column>
        <!--最小人数-->
        <el-table-column prop="minNumber"
                        :label="$t('couse.minnumber')"
                        header-align="center"
                        show-overflow-tooltip
                        align="center"></el-table-column>
        <!--课程状态-->
        <el-table-column prop="courseStatus"
                         :label="$t('couse.coursestatus')"
                         header-align="center"
                         align="center"
                         show-overflow-tooltip
                         :formatter="coursestatusformat"></el-table-column>
        <!--标准时长（天）-->
        <el-table-column prop="courseDays"
                         :label="$t('couse.coursedays')"
                         :formatter="courseDaysformat"
                         header-align="center"
                         show-overflow-tooltip
                         align="center"></el-table-column>
      </el-table>
      </div>
      <el-pagination :current-page="page"
                     :page-sizes="[10, 20, 50, 100]"
                     :page-size="limit"
                     :total="total"
                     layout="total, sizes, prev, pager, next, jumper"
                     @size-change="pageSizeChangeHandle"
                     @current-change="pageCurrentChangeHandle">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import catalogtree from '@/views/modules/learning/common/catalogtree'
import Vue from 'vue'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/learning/courseinfo/relaCoursePage',
        getDataListIsPage: true,
        deleteURL: '/learning/courseinfo/delete',
        undercarriageURL: 'learning/courseinfo/undercarriage'
      },
      // 课程分类树
      defaultPropsz: {
        children: 'children',
        label: 'catalogNameCn',
        id: 'catalogId'
      },
      showVehicleClassList: [],
      showValue: '',
      queryTreeUrl: '/learning/coursecatalog/list',
      dataForm: {
        offeringcoursecode: 'offering',
        courseStatuslist: '20',
        catalogId: '', // 课程分类
        courseTeamCatalogId: '', // 课程团队分类
        courseTeamCatalogFirst: '',
        courseTeamCatalogSecond: '', // 课程团队分类
        selectCatalogSecond: '',
        coursename: '' // 课程名称
      },
      // 等待转圈
      dataListLoading: false,
      select1: [],
      teamcatalogfirst: this.enums['catalogidList1'],
      loading: false,
      select2: [],
      allteamcatalog: [],
      teamcatalogsecond: this.enums['catalogidList2'],
      isteamPerm: true,
      coursestatusArr: this.enums['courseStatus'] // 课程状态
    }
  },
  props: {
    url: {// 文件提交位置
      type: String,
      required: true
    },
    teamPerms: { // 权限名称
      type: String,
      required: true
    }
  },
  components: {
    catalogtree
  },
  created () {
    this.getTeamRole()
    this.getTeamRoleParam()
  },
  activated () {
    this.init()
  },
  methods: {
    init () {
      this.resetQuery()
      this.queryCourse()
    },
    queryCourse () {
      this.page = 1
      this.getTeamRoleParam()
      this.getDataList()
    },
    couronOk () {
      let select = this.$refs.coursePlanTable.selection
      if (select.length <= 0) {
        this.$message.warning(this.$t('res.courseclassroomrela.courseSelectCheck'))
        return false
      }
      console.info(select[0].courseId)
      let _this = this
      _this.$request.get(this.url + `/${select[0].courseId}`).then((res, msg, code, data) => {
        if (data.data > 0) {
          _this.$message({
            message: _this.$t('res.courseclassroomrela.repeatQuery'),
            type: 'failed'
          })
          return false
        }
        let selectData = {}
        selectData.courseId = select[0].courseId
        selectData.courseNo = select[0].courseCode
        this.coursestatusArr.forEach(item => {
          if (item.code === select[0].courseStatus) {
            selectData.status = item.name
          }
        })
        selectData.coursecName = select[0].courseNameCn
        selectData.courseTime = select[0].courseDays
        selectData.maxPersonNo = select[0].maxNumber
        selectData.miniPersonNo = select[0].minNumber
        selectData.courseClass = select[0].courseCatalogName
        selectData.teamName = select[0].courseTeamCatalogName
        _this.$emit('couronOk', selectData)
        _this.$refs.coursePlanTable.clearSelection()
      })
    },
    // 课程分类调用树
    cateloglist: function (data) {
      let catalogId = ''
      let catalogNameCn = ''
      data[0].data.forEach(rows => {
        catalogId = catalogId + rows.catalogId + ','
        catalogNameCn = catalogNameCn + rows.catalogNameCn + ','
      })
      this.dataForm.catalogId = catalogId
    },
    // 单选
    selectRedio: function selectRedio (selection, row) {
      if (this.$refs.coursePlanTable.selection.length > 1) {
        this.$refs.coursePlanTable.clearSelection()
        this.$refs.coursePlanTable.toggleRowSelection(row)
      }
    },
    coursestatusformat (row) {
      return Vue.filter('coverEnum')(row.courseStatus, 'courseStatus')
    },
    courseDaysformat (row, column, cellValue) {
      if (cellValue) {
        return cellValue.toFixed(2)
      }
    },
    // 重置查询条件
    resetQuery () {
      this.$refs.catalogtree.resetChecked()
      this.dataForm.offeringcoursecode = 'offering'
      this.dataForm.catalogId = ''
      this.dataForm.courseTeamCatalogId = ''
      this.dataForm.courseTeamCatalogFirst = ''
      this.dataForm.courseTeamCatalogSecond = ''
      this.dataForm.selectCatalogSecond = ''
      this.dataForm.coursename = ''
      this.dataForm.courseStatuslist = '20'
    },
    GetcourseTeamCatalog (prov) {
      let tempArry = []
      this.select2 = []
      if (this.dataForm.selectCatalogSecond !== null || this.dataForm.selectCatalogSecond === '') {
        this.dataForm.selectCatalogSecond = ''
      }
      for (var val of this.allteamcatalog) {
        var code = val.code.slice(0, 2)
        if (prov === code) {
          tempArry.push({ name: val.name, code: val.code })
        }
        this.select2 = tempArry
      }
    },
    getTeamRole () {
      // 课程团队分类二级
      for (var val of this.teamcatalogsecond) {
        if (this.$hasPermission(this.teamPerms + ':'+ val.code)) {
          this.allteamcatalog.push(val)
        }
      }
      if (this.allteamcatalog.length === 0) {
        this.isteamPerm = false
        this.allteamcatalog = this.teamcatalogsecond
      }
      // 课程团队分类一级
      let tempArry = []
      for (var val of this.allteamcatalog) {
        var code = val.code.slice(0, 2)
        if (tempArry.indexOf(code) === -1) {
          tempArry.push(code)
        }
      }
      for (var val of this.teamcatalogfirst) {
        if (tempArry.indexOf(val.code) !== -1) {
          this.select1.push(val)
        }
      }
      if (this.select1.length === 0) {
        this.select1 = this.teamcatalogfirst
      }
    },
    getTeamRoleParam () {
      this.dataForm.courseTeamCatalogSecond = this.dataForm.selectCatalogSecond
      if ((this.dataForm.courseTeamCatalogSecond === null || this.dataForm.courseTeamCatalogSecond === '') && this.isteamPerm) {
        // 课程团队分类二级
        let tempArry = []
        for (var val of this.allteamcatalog) {
          tempArry.push(val.code)
        }
        if (tempArry.length > 0) {
          this.dataForm.courseTeamCatalogSecond = tempArry.join(',')
        }
      }
    }
  }
}
</script>
<style scoped>
.el-row {
  margin-bottom: 0px;
}
</style>
<style>
.selectRadioClass thead .el-table-column--selection .cell {
  display: none !important;
}
</style>
<style>
.single-search-condition .el-form-item__content {
  margin-left: 96px !important;
}

.jump-popup-course .el-form-item__label-wrap {
  margin-left: 28px !important;
}
.jump-popup-coursefenlei .el-form-item__label-wrap {
  margin-left: 0px !important;
}
.jump-popup-teamfenlei .el-form-item__content {
  margin-left: 120px !important;
}
</style>
